













import { Vue, Component } from "vue-property-decorator";

import TaxonomyForm from "@/components/taxonomy/TaxonomyForm.vue";

@Component({
  components: { TaxonomyForm }
})
export default class ProfessionalActivityTaxonomyNew extends Vue {}
